<template>
  <div>
    <div>
      <label class="ts-mb-0">{{ $t('productProfile.addOnItem') }}</label>
      <a-select
        v-model="model.recipes"
        mode="multiple"
        :maxTagCount="10"
        :options="recipeList"
        showSearch
        :filterOption="
          (input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
        "
        :disabled="model.product_type_id == 3"
        class="ts-w-full"
      ></a-select>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'addOnItem',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    recipeList() {
      return this.$store.state.product.profile.productRecipe.map(el => ({
        value: el.pro_sale_code_id,
        label: el.pro_group_name + '-' + el.product_name_en + '-' + el.sale_code
      }))
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
